import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const slides = [{
  src: 'https://cdn.magicpatterns.com/uploads/tpU7Pa3G8oWgHPmshnSAU3/Captura_de_pantalla_2026-09-08_a_la(s)_10.46.53_p._m..png',
  alt: 'Cours complet de 90 minutes avec déroulé de séance et qualité d\'enseignement'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/rfDW7M2DQhH6bvgfoFHY2z/Captura_de_pantalla_2026-09-08_a_la(s)_10.47.14_p._m..png',
  alt: 'Combinaison prête — niveau intermédiaire décomposée en 16 temps'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/si35Umo5YUjqFUwTdHvviH/Captura_de_pantalla_2026-09-08_a_la(s)_10.47.24_p._m..png',
  alt: 'Combinaison prête — niveau avancé avec indicateurs de contraste dynamique'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/nQy2B61zXjP1fkmvEyxRU1/Captura_de_pantalla_2026-09-08_a_la(s)_10.47.50_p._m..png',
  alt: 'Combinaison prête à utiliser — avancé avec blocs et accents musicaux'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/ameQn4mR9a82rAo62By2Bn/Captura_de_pantalla_2026-09-08_a_la(s)_10.48.11_p._m..png',
  alt: 'Changer de niveau — transitions entre les niveaux haut, moyen et bas'
}];
export function InsideCarousel() {
  const [index, setIndex] = useState(0);
  const goTo = (next: number) => {
    setIndex((next + slides.length) % slides.length);
  };
  return <section className="py-8 px-4 sm:px-6 bg-brand-cream border-b-4 border-brand-cream" data-id="element-103" data-mp="35sek7j7us9tq">
      <div className="text-center mb-5" data-id="element-104" data-mp="3aqpufv228mch">
        <h2 className="text-2xl sm:text-3xl font-heading font-bold text-brand-title mb-2 uppercase leading-tight" data-id="element-105" data-mp="3apognitntlr2">
          👀 NE NOUS CROYEZ PAS SUR PAROLE. REGARDEZ À L'INTÉRIEUR.
        </h2>
        <p className="text-sm sm:text-base text-brand-text font-medium leading-relaxed max-w-xl mx-auto" data-id="element-106" data-mp="3kfhhbos9kggj">
          Découvrez quelques-unes des ressources que vous pourrez réellement
          utiliser dans vos prochains cours.
        </p>
      </div>

      <div className="relative bg-white border-2 border-brand-gold/40 rounded-xl p-3 shadow-lg" data-id="element-107" data-mp="1tf7pwxvzrq2n">
        <div className="overflow-hidden rounded-lg bg-brand-ivory" data-id="element-108" data-mp="1pdmhboqhpxy9">
          <img src={slides[index].src} alt={slides[index].alt} className="w-full h-auto object-contain mx-auto" data-id="element-109" data-mp="1pfh3159l5u3e" />
        </div>

        <button type="button" onClick={() => goTo(index - 1)} aria-label="Ressource précédente" className="absolute left-1 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-white/95 border border-brand-rose/30 text-brand-rose shadow-md flex items-center justify-center hover:bg-brand-rose hover:text-white transition-colors duration-200" data-id="element-110" data-mp="1yd9g02ru4pnm">
          <ChevronLeftIcon className="w-5 h-5" data-id="element-111" data-mp="2h4k7om5dx6gk" />
        </button>
        <button type="button" onClick={() => goTo(index + 1)} aria-label="Ressource suivante" className="absolute right-1 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-white/95 border border-brand-rose/30 text-brand-rose shadow-md flex items-center justify-center hover:bg-brand-rose hover:text-white transition-colors duration-200" data-id="element-112" data-mp="rpvvom0phqj2">
          <ChevronRightIcon className="w-5 h-5" data-id="element-113" data-mp="33f220b6um2cf" />
        </button>
      </div>

      <div className="flex justify-center items-center gap-2 mt-4" data-id="element-114" data-mp="2plki2pa92nlv">
        {slides.map((slide, i) => <button key={slide.src} type="button" onClick={() => goTo(i)} aria-label={`Voir la ressource ${i + 1}`} aria-current={i === index} className={`h-2.5 rounded-full transition-all duration-200 ${i === index ? 'w-6 bg-brand-rose' : 'w-2.5 bg-brand-rose/30 hover:bg-brand-rose/60'}`} data-id="element-115" data-mp="2tll4ox7i6540" data-mpi={i} />)}
      </div>

      <p className="text-center text-xs font-button font-bold text-brand-text/70 uppercase tracking-wider mt-3" data-id="element-116" data-mp="4vbzbzgqedy5">
        {index + 1} / {slides.length}
      </p>
    </section>;
}